/**
 * §11 open item #3: "Final CARDS_PER_SESSION — 20 is a starting guess."
 * Phase 3 implementation choice, not owner-reviewed: cap a session at this
 * many cards at first. Visitors can then choose to rate more in batches of
 * RATE_MORE_BATCH (2026-10-11 owner decision; docs/ARCHITECTURE.md §13).
 */
export const CARDS_PER_SESSION = 20;

/** Cards added each time a visitor picks "Rate more" after reaching the cap. */
export const RATE_MORE_BATCH = 10;

/** Phase 3 draft demographic option sets — not specified anywhere in
 * docs/ARCHITECTURE.md (§11 / issues.md flags the exact question set/values
 * as undecided). Values are the wire values sent to the Worker; labels are
 * what the UI shows. Revisit with the owner alongside the submit contract. */
export const DEMOGRAPHIC_OPTIONS = {
  age_range: [
    ["under_18", "Under 18"],
    ["18_24", "18–24"],
    ["25_34", "25–34"],
    ["35_44", "35–44"],
    ["45_54", "45–54"],
    ["55_64", "55–64"],
    ["65_plus", "65+"],
  ],
  party_affiliation: [
    ["democrat", "Democrat"],
    ["republican", "Republican"],
    ["independent", "Independent"],
    ["other", "Other"],
  ],
  voted_2020: [
    ["biden", "Biden"],
    ["trump", "Trump"],
    ["other", "Other"],
    ["didnt_vote", "Didn't vote"],
  ],
  voted_2024: [
    ["trump", "Trump"],
    ["harris", "Harris"],
    ["other", "Other"],
    ["didnt_vote", "Didn't vote"],
  ],
} as const;

/** Maps a voted_2020/voted_2024 wire value to the `reveal.administration`
 * label it corresponds to, for the reveal screen's per-president breakdown
 * (presidentBreakdown.ts). Only winning candidates have an administration in
 * the deck — "harris"/"other"/"didnt_vote" intentionally have no entry. */
export const VOTE_TO_ADMINISTRATION: Record<string, string> = {
  biden: "Biden",
  trump: "Trump",
};

/** Placeholder intro-screen copy (feedback round 1: "don't jump right into
 * the cards"). Deliberately just a few plain strings here, not a template
 * system, so it's trivial to hand-edit without touching main.ts. */
export const INTRO_COPY = {
  heading: "Whose Policy Is It?",
  body: [
    "Do you dislike a president, or just the policies you associate with them? If you didn't know who was behind a decision, would your opinion change?",
    "You'll see real policies from US presidents of both parties over the last 70 years, without being told which president or party was behind each one.",
    "Rate each one on your gut feeling, from strongly oppose to strongly support. At the end, we reveal which president was behind each one and how your ratings compare to each party and president.",
  ],
  cta: "Start rating",
} as const;

export const US_STATES: [string, string][] = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["DC", "District of Columbia"],
  ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"],
  ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"],
  ["ME", "Maine"], ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
  ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"],
  ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"],
  ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"],
  ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"],
  ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"],
  ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
];
